module.exports = __webpack_public_path__ + "static/suncrest-logo-bc386fedd31d08121cfb8925693f2f85.png";